/** Retrieves an environment variable by key and optionally enforces its presence. */
function getEnvVar(key: string, isRequired = false): string | undefined {
  const value = (import.meta.env as any)[key];

  if (value === undefined && isRequired) {
    console.error(`❌ Environment variable ${key} is missing. Please check your .env file.`);
    throw new Error(`❌ Environment variable ${key} is missing. Please check your .env file.`);
  }

  return value;
}

const env = {
  API_URL: getEnvVar('VITE_API_URL', false) as string,
  NODE_ENV: import.meta.env.MODE || 'production',
};

const isDev = env.NODE_ENV === 'development';

const AUTH_LS_KEYS = {
  TOKEN: 'authToken',
  USER: 'userData',
  ROLE: 'role',
} as const;

export const USER_ROLES = {
  ADMIN: 'admin',
  ANALYST: 'analyst',
  ACCOUNTS: 'accounts',
  EMPLOYEE: 'employee',
  HR: 'hr',
  SITE_ENGINEER: 'site_engineer',
} as const;

export type UserRole = (typeof USER_ROLES)[keyof typeof USER_ROLES];

export const ROLES: UserRole[] = Object.values(USER_ROLES);

export const config = {
  isDev,
  env,
  AUTH_LS_KEYS,
  USER_ROLES,
  ROLES,
};
